import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";


export type ConfirmDialogProps = {
  onConfirm?: () => void;
  title: string;
  content: string;
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
};

const useStyles = makeStyles(() => ({
  actions: {
    padding: 15,
  },
}));

export default function ConfirmDialog(props: ConfirmDialogProps) {
  const { onConfirm, title, content, show, setShow } = props;

  const classes = useStyles();

  const onClick = () => {
    if (onConfirm !== undefined) {
      onConfirm();
      setShow(false);
    }
  };

  return (
    <div>
      <Dialog open={show} maxWidth="sm" fullWidth onClose={setShow}>
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button onClick={() => setShow(false)}>Cancel</Button>
          <Button data-test={"confirm-dialogue-confirm-button"} onClick={() => onClick()} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
